// extracted by mini-css-extract-plugin
export default {"navLink":"shared_navLink__EWOoz","selected":"shared_selected__ldixI"};